export default __webpack_public_path__ + "static/media1-19a7c3b17a6b444400efc9b56740f24f.jpg";